export default __webpack_public_path__ + "static/media/start_button.8d9a9b52.jpg";